import React, { PureComponent } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './styles/App.css';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect, isLoaded } from 'react-redux-firebase';
import TodoApp from './components/TodoApp.tsx';
import UserForm from './components/UserForm';
import TodoLoading from './components/TodoLoading';


class App extends PureComponent{
  constructor(props){
    super(props);
    // this.state = {
    //   genderStyle: 'male',
    //   lisnUem: '',
    //   lisnUid: '',
    //   lisnTodos: [],
    // }
    this.state = {
      genderStyle: 'male'    
    }
  }
  
  // componentDidUpdate(prevProps){
  //   if( this.props !== prevProps ){
  //     this.setState({ ...this.state, lisnUem: this.props.Uem, lisnUid: this.props.Uid, lisnTodos: this.props.Todos });
  //   }
  // }

  componentWillUnmount(){
    this.setState({ genderStyle: 'male' });
  }

  render(){
    const { Uem, Uid, Todos, UAuth} = this.props;
    console.log(this.state);
    return (
      (!isLoaded(UAuth)) 
      ? <TodoLoading />      
      : <Router>
        <div className={'App'}>
          <Routes>                
            <Route path='/' element={<Navigate to='/reactTodoSignIn' />} />
            {/* <Route path='/reactTodo'  element={<TodoApp genderStyle={ this.state.genderStyle} todos={this.state.lisnTodos} todosNoId={this.state.lisnTodos} uid={this.state.lisnUid} uem={this.state.lisnUem}/>} /> */}
            <Route path='/reactTodo'  element={<TodoApp genderStyle={ this.state.genderStyle } />} />
            <Route path='/reactTodoSignIn'  element={<UserForm formType = 'logIn' genderStyle={this.state.genderStyle} />} />
            <Route path='/reactTodoSignUp'   element={<UserForm formType = 'signUp' />} />
          </Routes>
        </div>
      </Router>
    )
  }
}

// export default App;

// let uemListener = '';
// const mapStateToProps = state => {
//   const uauth = state.firebase.auth;
//   const uem = state.firebase.auth.email;
//   const uid = state.firebase.auth.uid;
//   uemListener = uem;
//   const todos = state.firestore.ordered[`User-${uem}`];
  
//   return{ Uem: uem, Uid: uid, Todos: todos, UAuth: uauth }
// };

// export default compose(
//   connect(mapStateToProps),
//   firestoreConnect((ownProps) => [
//     { collection: `User-${ uemListener }`,   orderBy: ["createdAt", "desc"]},
//   ])
// )(App);

const mapStateToProps = state => {
  const uauth = state.firebase.auth;  
  return{ UAuth: uauth }
};

export default connect(mapStateToProps, null )( App );